import { DEFAULT_FEATURE_KEY, INTERNAL_COOKIE_FEATURE_NAMES, INTERNAL_BROWSER_FEATURE_QUERY_KEYS, INTERNAL_SERVER_FEATURE_QUERY_KEY, PUBLIC_COOKIE_FEATURE_NAMES, PUBLIC_BROWSER_FEATURE_QUERY_KEYS, PUBLIC_SERVER_FEATURE_QUERY_KEY } from './constants';

// Keys are hardcoded intentionally, to prevent babel error in SB api
export var mapFeatureKeyToValues = {
    internal: {
        cookieFeatureNames: INTERNAL_COOKIE_FEATURE_NAMES,
        browserFeatureQueryKeys: INTERNAL_BROWSER_FEATURE_QUERY_KEYS,
        serverFeatureQueryKey: INTERNAL_SERVER_FEATURE_QUERY_KEY
    },
    public: {
        cookieFeatureNames: PUBLIC_COOKIE_FEATURE_NAMES,
        browserFeatureQueryKeys: PUBLIC_BROWSER_FEATURE_QUERY_KEYS,
        serverFeatureQueryKey: PUBLIC_SERVER_FEATURE_QUERY_KEY
    }
};

var getFeatureKeyValues = function getFeatureKeyValues(featureKey) {
    return mapFeatureKeyToValues[featureKey] || mapFeatureKeyToValues[DEFAULT_FEATURE_KEY];
};

export var getCookieFeatureNames = function getCookieFeatureNames(featureKey) {
    return getFeatureKeyValues(featureKey).cookieFeatureNames;
};

export var getBrowserFeatureQueryKeys = function getBrowserFeatureQueryKeys(featureKey) {
    return getFeatureKeyValues(featureKey).browserFeatureQueryKeys;
};

export var getServerFeatureQueryKey = function getServerFeatureQueryKey(featureKey) {
    return getFeatureKeyValues(featureKey).serverFeatureQueryKey;
};